import { z } from "zod";

import type { PortalUser } from "@/app/models";
import type { Subscription } from "@/features/billing/models";
import { privateAPI } from "@/shared/lib";
import type { ServiceResponse } from "@/shared/lib/axios";
import type { USState } from "@/shared/models/legacy-types";
import type { Provider, ScheduleAppointment } from "../models";
import { providerSchema, scheduleAppointmentSchema } from "../models";

export interface GetProvidersParams {
  language: ScheduleAppointment["language"];
  appointmentType: ScheduleAppointment["type"];
  state: USState["value"];
}

export const getProviders = async (params: GetProvidersParams) => {
  const { data } = await privateAPI.get<ServiceResponse<unknown>>(
    `/providers`,
    { params },
  );

  return z.array(providerSchema).parse(data.data);
};

export interface GetAvailabilityParams
  extends Omit<GetProvidersParams, "state"> {
  date: ScheduleAppointment["date"];
  userId?: PortalUser["patientId"];
  providerId?: Provider["id"];
  subscriptionId?: Subscription["id"];
  originalDate?: ScheduleAppointment["date"];
}

export const getAvailableDays = async (params: GetAvailabilityParams) => {
  const { date, ...restParams } = params;
  const { data } = await privateAPI.get<ServiceResponse<unknown>>(
    `/providers/available-days-in-month`,
    { params: { dateFromMonth: date, ...restParams } },
  );

  return z.array(scheduleAppointmentSchema.shape.date).parse(data.data);
};

export const getAvailableTimeSlots = async (params: GetAvailabilityParams) => {
  const { data } = await privateAPI.get<ServiceResponse<unknown>>(
    `/providers/time-slots`,
    { params },
  );

  return z.array(scheduleAppointmentSchema.shape.timeSlot).parse(data.data);
};
